import { render } from "./PluginIcon.vue?vue&type=template&id=13037b00&scoped=true&ts=true"
import script from "./PluginIcon.vue?vue&type=script&lang=ts"
export * from "./PluginIcon.vue?vue&type=script&lang=ts"

import "./PluginIcon.vue?vue&type=style&index=0&id=13037b00&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13037b00"]])

export default __exports__